const updates = [
  {
    time: '2分钟前',
    tag: '最新',
    title: '某知名综艺节目录制现场发生冲突，两位嘉宾当场翻脸',
    tagColor: 'bg-primary-500',
  },
  {
    time: '15分钟前',
    tag: '快讯',
    title: '网曝某电商平台数据造假，双十一销量水分高达40%',
    tagColor: 'bg-accent-500',
  },
  {
    time: '32分钟前',
    tag: '独家',
    title: '某影视公司内部邮件泄露，揭开了艺人片酬的惊天秘密',
    tagColor: 'bg-primary-500',
  },
  {
    time: '1小时前',
    tag: '跟进',
    title: '昨日曝光的某导演潜规则事件，已有第三位受害者站出来',
    tagColor: 'bg-secondary-500',
  },
  {
    time: '2小时前',
    tag: '快讯',
    title: '某地政府部门被曝公款吃喝，一顿饭消费超3万元',
    tagColor: 'bg-accent-500',
  },
  {
    time: '3小时前',
    tag: '深扒',
    title: '深挖某头部MCN机构：签约主播的霸王条款究竟有多黑',
    tagColor: 'bg-primary-500',
  },
  {
    time: '4小时前',
    tag: '独家',
    title: '某知名投资人涉嫌内幕交易，证监会已正式立案调查',
    tagColor: 'bg-primary-500',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
          24小时快讯
        </h2>

        <div className="relative pl-8 border-l-2 border-primary-200">
          {updates.map((item, i) => (
            <div key={i} className={`relative pb-6 ${i === updates.length - 1 ? 'pb-0' : ''}`}>
              <div className="absolute -left-[33px] top-0 w-4 h-4 rounded-full border-2 border-primary-200 bg-background-50"></div>
              <div className="flex items-center gap-3 mb-1 flex-wrap">
                <span className="text-xs text-foreground-500">{item.time}</span>
                <span className={`text-xs ${item.tagColor} text-background-50 px-2 py-0.5 rounded font-medium`}>
                  {item.tag}
                </span>
              </div>
              <p className="text-sm md:text-base text-foreground-900 font-medium leading-snug cursor-pointer hover:text-primary-500 transition-colors">
                {item.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}